var _style, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentsBreached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 23,
    viewBox: "0 0 70 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400&display=swap');\n    text { font-family: 'Open Sans', sans-serif; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fbf8f3",
    stroke: "#a84032",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 23,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 22,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 16,
    textAnchor: "middle",
    fill: "#a84032",
    fontSize: 12
  }, "\n    BREACHED\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentsBreached);
export default __webpack_public_path__ + "static/media/percents-breached.e35ba247484fb1bb82a5857dfaf5e867.svg";
export { ForwardRef as ReactComponent };